export default "__VITE_ASSET__GzFcdAFp__"